import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'

import { GapBox } from 'components/Box'
import { TextLink } from 'components/Link'
import Paper from 'components/Paper'
import { TableHeader } from 'components/Table'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes'
import { WorkspacePrebidModuleTable } from '../../components/WorkspacePrebidModuleTable'
import { KNOWLEDGE_BASE_URL } from './constants'
import { useColumns } from './hooks/useColumns'

export const VendorSpecificList = (): React.JSX.Element => {
  const ability = useAbility()
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation(['features/globalSetup', 'common'])
  const columns = useColumns()

  const navigate = useNavigate()

  const AddVendorSpecificButton = (): React.JSX.Element => (
    <Button
      data-cy='add-vendor-specific-button'
      onClick={() =>
        navigate(
          generatePath(ROUTES.GLOBAL_SETUP.PREBID.MODULES.VENDOR_SPECIFIC.ADD, { workspaceId }),
        )
      }
      variant='contained'
    >
      {t('common:actions.addNew')}
    </Button>
  )

  return (
    <Paper>
      <TableHeader
        actions={
          ability.can('create', 'GlobalSetupFeature-vendorSpecific') ? (
            <AddVendorSpecificButton />
          ) : undefined
        }
        description={t('prebid.modules.vendorSpecific.list.description')}
        descriptionEndAdornment={
          <TextLink
            link={{
              title: t('common:learnMore'),
              url: KNOWLEDGE_BASE_URL,
            }}
          />
        }
        title={t('prebid.modules.vendorSpecific.list.title')}
      />

      <GapBox />

      <WorkspacePrebidModuleTable
        columns={columns}
        moduleType='vendorSpecific'
      />
    </Paper>
  )
}
